import { Language } from './languages';

// The rest of the platform (card-service, DiPocket, the Apple Wallet terms) only supports
// these languages, stored on the account as a bare code. Any other UI language is stored as en.
const PLATFORM_TO_UI_LANGUAGE = {
	de: Language.DE,
	en: Language.EN,
	es: Language.ES,
};

const DEFAULT_PLATFORM_LANGUAGE = 'en';

// 'de-DE' → 'de', 'fr-FR' → 'en'. Also accepts legacy account values like 'DE' or 'de_DE'.
export const toPlatformLanguage = (code) => {
	const primary = typeof code === 'string' ? code.trim().split(/[-_]/)[0].toLowerCase() : '';
	return Object.hasOwn(PLATFORM_TO_UI_LANGUAGE, primary) ? primary : DEFAULT_PLATFORM_LANGUAGE;
};

// 'de' → 'de-DE'. Used to show the portal in the language stored on the account.
export const fromPlatformLanguage = (code) => PLATFORM_TO_UI_LANGUAGE[toPlatformLanguage(code)];
